export default __webpack_public_path__ + "static/media/signature.6316f02b.png";